import React, { Component } from "react";
import "./splashDark.scss";
import { motion } from "framer-motion"
import SplashDarkBg from "./static/bgDark.svg";
import SplashDarkResBg from "./static/splashDarkResBg.svg";
import SmallBerryRight from "./static/smallBerryRight.svg";
import SmallBerryLeft from "./static/smallBerryLeft.svg";
import SplashMusic from "./static/splashMusic.mp3";

export default class Splash extends Component {
  constructor(props) {
    super(props);
    this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    this.splashMusic = new Audio(SplashMusic);
    window.splashMusic = this.splashMusic;
    this.splashMusic.volume = 0.5;
  }
  componentDidMount() {
    // tries to prevent browser's first touch document rule
    setTimeout(() => {
      this.splashMusic.play();
    }, 2000)
  }

  componentWillUnmount() {
    this.splashMusic.pause();
  }
  
  render() {
    return (
      <div className="splashDark">
        {/* <img className="cracked wall" src={Wall} alt="wall"/>
        <img className="cracked wallRight" src={WallRight} alt="wall"/> */}
        {/* <img className="bgDark" src={SplashDarkBg} alt="bg" /> */}
        {/* <div className="bgDark"></div> */}
        {!this.isMobile && <img alt="bg" className="darkBg" src={SplashDarkBg} />}
        {this.isMobile && <img alt="bg" className="darkResBg" src={SplashDarkResBg} />}

        <div className="details-container">
            <h6 className="title mb-16 mr-10">FREEBERRY</h6>

            <div className="flex mb-16">
                <img className="berry1" src={SmallBerryLeft} alt="berry" />
                <img className="berry2" src={SmallBerryRight} alt="berry" />
            </div>

            <div className="desc mb-20">
                Get ‘em enchanted berries!
            </div>

            <motion.button 
                className="btn btn-splash" 
                onClick={() => {
                    this.props.beginGame("game");
                }}
                initial={{ x: -10000 }}
                animate={{ x: 0 }}
                >
                Begin playing
                <img
                    src={require("./static/play.svg")}
                    alt="play-button"
                />
            </motion.button>
        </div>
      </div>
    );
  }
}
